import { Site, SiteFeatureFlagValue, TestValues } from "./modelTypes";

export { SiteFeatureFlag } from "./modelTypes";

/**
 * Reads a feature flag for a site, checking the dedicated feature_flags field
 * first and falling back to site_details for sites created before the migration.
 */
export const getSiteFeatureFlag = (
  site: Site,
  flagName: SiteFeatureFlagValue,
): TestValues | undefined =>
  site.featureFlags?.[flagName] ??
  (site.siteDetails as unknown as Record<string, TestValues | undefined>)?.[
    flagName
  ];
